// en, de, fr, pt
export default {
  en: {
    Dashboard: 'Dashboard',
    FileExport:"Choose file location to save CSV",
    eCommerce: 'eCommerce',
    TraineeParticipation: 'Trainee Participation',
    PracticalProcess: 'Practical Process',
    Apps: 'Apps',
    Todo: 'Todo',
    Chat: 'Chat',
    Email: 'Email',
    Calendar: 'Calendar',
    FullCalendar: 'Full Calendar',
    SimpleCalendar: 'Simple Calendar',
    Shop: 'Shop',
    ResendCode: "Resend Code",
    Cart: 'Cart',
    WishList: 'Wish List',
    Checkout: 'Checkout',
    UI: 'UI',
    DataList: 'Data List',
    ListView: 'List View',
    ThumbView: 'Thumb View',
    Grid: 'Grid',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Colors',
    Card: 'Card',
    Basic: 'Basic',
    Statistics: 'Statistics',
    Analytics: 'Analytics',
    CardActions: 'Card Actions',
    CardColors: 'Card Colors',
    Table: 'Table',
    agGridTable: 'agGrid Table',
    Components: 'Components',
    Alert: 'Alert',
    Avatar: 'Avatar',
    Badge: 'Badge',
    Breadcrumb: 'Breadcrumb',
    Button: 'Button',
    ButtonGroup: 'Button Group',
    Chip: 'Chip',
    Collapse: 'Collapse',
    Dialogs: 'Dialogs',
    Divider: 'Divider',
    DropDown: 'DropDown',
    List: 'List',
    Loading: 'Loading',
    Navbar: 'Navbar',
    Notifications: 'Notifications',
    Pagination: 'Pagination',
    Popup: 'Popup',
    Progress: 'Progress',
    Sidebar: 'Sidebar',
    Slider: 'Slider',
    Tabs: 'Tabs',
    Tooltip: 'Tooltip',
    Upload: 'Upload',
    FormsAndTable: 'Forms & Table',
    FormElements: 'Form Elements',
    Select: 'Select',
    Switch: 'Switch',
    Checkbox: 'Checkbox',
    Radio: 'Radio',
    Input: 'Input',
    NumberInput: 'Number Input',
    Textarea: 'Textarea',
    FormLayouts: 'Form Layouts',
    FormWizard: 'Form Wizard',
    FormValidation: 'Form Validation',
    FormInputGroup: 'Form Input Group',
    Pages: 'Pages',
    Authentication: 'Authentication',
    Login: 'Login',
    Register: 'Register',
    ForgotPassword: 'Forgot Password',
    ResetPassword: 'Reset Password',
    LockScreen: 'Lock Screen',
    Miscellaneous: 'Miscellaneous',
    ComingSoon: 'Coming Soon',
    Error: 'Error',
    404: '404',
    500: '500',
    NotAuthorized: 'Not Authorized',
    Maintenance: 'Maintenance',
    Profile: 'Profile',
    Invoice: 'Invoice',
    FAQ: 'FAQ',
    Search: 'Search',
    KnowledgeBase: 'Knowledge Base',
    ChartsAndMaps: 'Charts & Maps',
    Charts: 'Charts',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Map',
    Extensions: 'Extensions',
    QuillEditor: 'Quill Editor',
    DragAndDrop: 'Drag & Drop',
    Datepicker: 'Datepicker',
    DatetimePicker: 'Datetime Picker',
    AccessControl: 'Access Control',
    I18n: 'I18n',
    Carousel: 'Carousel',
    Clipboard: 'Clipboard',
    ContextMenu: 'Context Menu',
    StarRatings: 'Star Ratings',
    Autocomplete: 'Autocomplete',
    Tree: 'Tree',
    // "Import/Export": 'Import/Export',
    Import: 'Import',
    Export: 'Export',
    ExportSelected: "Export Selected",
    Others: 'Others',
    MenuLevels: 'Menu Levels',
    MenuLevel2p1: 'Menu Level 2.1',
    MenuLevel2p2: 'Menu Level 2.2',
    MenuLevel3p1: 'Menu Level 3.1',
    MenuLevel3p2: 'Menu Level 3.2',
    DisabledMenu: 'Disabled Menu',
    Support: 'Support',
    Documentation: 'Documentation',
    RaiseSupport: 'Raise Support',
    demoTitle: 'Card Title',
    demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.',
    /* custom i18n data */
    Course: "Course",
    CourseCatalog: "Course catalog",
    Instructor: "Instructor",
    Planning: "Planning",
    AnnualPlan: "Annual Plan",
    Setting: "System Lookups",
    Language: "Language",
    Facility: "Training Aid",
    QuestionType: "Question Type",
    QuestionLevel: "Question Level",
    QuestionBank: "Question Bank",
    ExamType: "Exam Type",
    ClassRoom: "Class Room",
    CourseType: "Course mode",
    CourseLevel: "Course Level",
    MaterialType: "Material Type",
    PopulationList: "Who should attend this course",
    IndustrySector: "Industry Sector",
    AreaOfStudy: "Area Of Study",
    CourseCategory: "Course Category",
    Nationality: "Nationality",
    MaritalStatus: "Marital Status",
    ContactType: "Contact Type",
    EducationDegree: "Education Degree",
    Customer: "Customer",
    Trainee: "Trainee",
    UserManagement: "User Management",
    Home: "Home",
    Users: "Users",
    YearSummary: "Year Summary",
    CourseClass: "Course Class",
    Question: "Question",
    Reports: "Reports",
    CourseRegistration: "Course Registration",
    CourseRequest: "Course Request",
    EnrollmentManagement: "Enrollment Management",
    TestManagement: "Test Management",
    CourseExam: "Course Exam",
    ExamGeneration: "Exam Generation",
    QuestionCategory: "Question Category",
    CustomerReview: "Customer Review",
    CategoryAssessment: "Category Assessment",
    AssessmentType: "Assessment Type",
    PaymentType: "Payment Type",
    RequestLocation: "Request Location",
    ProposalTemplate: "Customized Proposal",
    ProposalStatus: "Proposal Status",
    InstructorPlaning: "Instructor Planning",
    InstructorMarkExam: "Instructor Mark Exam",
    TraineeAttendance: "Trainee Attendence",
    AdvertisementEmail: "Advertisement Email",
    Diplomas: "Diplomas",
    Schedule: "Schedule",
    MarkExam: "Mark Exam",
    PracticalDegrees: "Practical Degrees",
    TraineeFeedback: "Trainee Feedback",
    TraineeCoursesPass: "Trainee Courses Pass",

    CourseMaterial: "Course Material",
    YourExams: "Your Exams",
    CourseFeedback: "Course Feedback",
    ExamResult: "Exam Result",
    Holiday: "Holiday",
    RoomPlan: "Room Plan",
    advertisement: "advertisement",

    FollowRegistration: "Follow Registration",
    FollowCourseRequest: "Make or Follow Course Request",
    TraineeCertification: "Trainee Certification",
    InstructorAssessment: "Instructor Assessment",
    AssessmentQuestion: "Assessment Question",
    AssessmentCreation: "Assessment Creation",
    AssessmentProcess: "Assessment Process",
    AssessmentResult: "Assessment Result",
    TraineeFollow: "Trainee Follow",
    TraineeExamsAnswers: "Trainee Exams Answers",
    ExaminationManagement: "Examination Management",
    ExamRule: "Exam Rule",
    PracticalExamination: "Practical Examination",
    PracticalEvaluationQuestion: "Practical Evaluation Question",
    Feedback: "Feedback",
    FeedbackQuestion: "Feedback Question",
    RecordsReports: "Records & Reports",
    QuestionPassStatistics: "Question Pass Statistics",
    CoursePassStatistics: "Course Pass Statistics",

    Organizations: "Organizations",
    Customers: "Organizations",
    Trainees: "Trainees",
    AdditionalServices: "Additional Services",
    AnnualCalender: "Annual Calender",
    CustomerFeedbackCategory: "Customer Feedback Category",
    Country: "Country",
    GeneralImage: "General Image",
    GenerateCode: "Generate Code",
    GeneralSetting: "General Setting",
    ParticipationType: "Participation Type",

    Provider: "Provider",
    ReportManagement: "Report Management",
    RoomHotel: "Room",
    RoomHotelFacility: "Room Facility",
    RoomHotelType: "Room Type",
    RoomHotelPrice: "Room Price",
    StatusMailTemplate: "Status Mail Template",
    SystemMailTemplate: "System Mail Template",
    Status: "Status",
    TrainingStrategy: "Training Strategy",
    UserTitle: "User Title",
    HomeTitle: "Welcome to Training Management System",
    UpCamminCourse: "Upcoming Course Classes",
    ClassNo: "Training Order NO",
    CourseName: "Course Name",
    Period: "Period",
    Level: "Level",
    PreferredLanguage: "Preferred Language",
    CourseLanguage: "Course Language",
    CourseLanguageName: "Course Language Name",
    OtherLanguage: "Other Language",
    OtherCourse: "Other Course",
    InstructorIndustrySector: "Instructor Industry Sector",
    NotifyAccordingToIndustrySector: "Notify according to industry sector",
    DiplomaCourses: "DiplomaCourses",
    Module: "Module",
    Action: "Action",
    Name: "Name",
    Reset: "Reset",
    DeliveryMethod: "Delivery Method",
    AddRule: "Add Rule",
    ExamStartDate: "Exam Start Date",
    Price: "Price",
    FullName: "Full Name",
    JobTitle: "Job Title",
    JobTitleRequied: "Job Title * ",
    ContactPersonJobTitle: "Contact person job title *",
    Code: "Code",
    InternalCourseCode: "Internal Course Code",
    CourseCode: "Course Code",
    CourseClassCode: "Course Class Code",
    Category: "Category",
    DurationInHour: "Duration In Hour",
    EndOfModule: "End Of Module",
    NameAsPassport: "Name As Passport",
    ExamCode: "Exam Code",
    Result: "Result",
    PassportNumber: "Passport Number",
    PassportPath: "Passport Path",
    VisaProof: "Visa Proof",
    FlightTicket: "Flight Ticket",
    WithAccommodation: "With Accommodation",
    RoomType: "Room Type",
    SortBy: "Sort By",
    StartDate: "Start Date",
    References: "References",
    RegistrationDue: "Registration Due Date",
    Title: "Title",
    Instructors: "Instructors",
    EvaluationMean: "Evaluation Mean",
    Percentage: "Percentage",
    Num: "Num",
    TrainingAd: "Training Ad",
    NewTrainingAd: "New Training Ad",
    VisiableByTrainee: "Visiable By Trainee",
    Hours: "Hours",
    Subject: "Subject",
    EndDate: "End Date",
    Start: "Start",
    End: "End",
    From: "From",
    To: "To",
    TypeName: "Type Name",
    ReviewCode: "Review Code",
    CourseHours: "Course Hours",
    AddSession: "Add Session",
    Content: "Content",
    CourseStartDate: "Course Start Date",
    ClassRoomName: "Class Room Name",
    StartExam: "Start Exam",
    CurrentPosition: "Current Position",
    TotalRegistration: "Total Registration",
    ConfirmedRegistration: "Confirmed Registration",
    MailType: "Mail Type",
    Delete: "Delete",
    IsRegistration: "Is Registration",
    MailTemplate: "Mail Template",
    ShoWHideTamplate: "Show/Hide Tamplate",

    NumberOFQuestion: "Number of Question",
    QuestionText: "Question text",
    ModelAnswer: "Model Answer",
    Cancel: "Cancel",
    Submit: "Submit",
    Print: "Print",
    Session: "Session",
    SessionDay: "Session Day",
    LastModuleCode: "Last Module Code",
    NewModule: "New Module",
    AllInstructors: "All instructors",
    InstructorsByCourse: "instructors by course",
    QuestionNum: "Question num",
    Answers: "Answers",
    Pass: "Pass",
    Weight: "Weight",
    Grade: "Grade",
    Back: "Back",
    PassDegree: "Pass Degree",
    PassDegreeIn: "Pass Degree In",
    PassInfo: "Pass info",
    Failed: "Failed",
    ExcellentDegree: "Excellent Degree",
    Color: "Color",
    Version: "Version",
    ViewPorposal: "View Proposal",
    Type: "Type",
    Download: "Download",
    LoadTrainee: "Load Trainee",
    TrainingOrderNumber: "Training order number",
    TrainingOrderNumberCourseClass: "Course Class/Training order number",
    ParticipationRange: "participation degree from 1 to 10",
    ShowQuestion: "Show Question",
    MailBody: "Mail Body",
    EvaluationMain: "Evaluation Mean",
    CurrentStatus: "Current Status",
    RequestStartDate: "Request Start Date",
    Organization: "Organization",
    OrganizationContact: "Organization Contact",
    NoOfTrainee: "No Of Trainee",
    TraineeName: "Trainee Name",
    ExtraTraineeAnswer: "Extra Trainee answer",
    UploadByTrainee: "Upload By Trainee",
    TraineeAnswer: "Trainee Answer",
    NoAnswer: "No Answer",
    AnswerDate: "Answer Date",
    BudgetForTrainee: "Budget for trainee",
    BudgetForCourse: "Budget for course",
    NoStatus: "no status",
    ContactText: "Contact Text",
    AddContact: "Add Contact",
    AttachmentDescription: "Attachment Description",
    Date: "Date",
    TraineeFullName: "Trainee FullName",
    PhoneNumber: "PhoneNumber",
    OrganizationName: "Organization Name *",
    UserName: "User Name",
    IsNew: "Is New",
    URL: "URL",
    Examiner: "Examiner",
    IsExaminer: "IsExaminer",
    PracticalAssessor: "Practical Assessor",
    IsPracticalAssessor: "Is Practical Assessor",
    IsInstuctor: "Is Instuctor",
    EducationDegreeType: "Education Degree Type",
    DateFrom: "Date From",
    DateTo: "Date To",
    ContentText: "Content Text",
    SchoolOrUniversity: "School Or University",
    AddLanguage: "Add Language",
    ObtainedDate: "Obtained Date",
    Work: "Work",
    WorkArea: "Work area",
    AddArea: "Add Area",
    InstructorConfirmAttended: "Instructor Confirm Attended",
    AddSector: "Add Sector",
    TotalFeesForTrainee: "Total Fees For Trainee",
    Mark: "Mark",
    IsRight: "Is Right",
    AddTextAnswer: "Add Text Answer",
    AddAttachmentAnswer: "Add Attachment Answer",
    AnswerText: "Answer Text",
    Description: "Description",
    DescriptionOfAttachment: "Description Of Attachment",
    MinNoOfTrainee: "Min No Of Trainee",
    For: "For",
    Calender: "Calender",
    Year: "Year",
    MaxNoOfTrainee: "Max No Of Trainee",
    AddTrainingAid: "Add Training Aid",
    Image: "Image",
    MinTimeOfMarkExamPerDay: "Min Time Of Mark Exam Per Day",
    AdvertisementResponsible: "Advertisement Responsible Name",
    AdvertisementPhone: "Advertisement Phone",
    AddFacility: "Add Facility",
    DefaultPrice: "Default Price",
    NumberOfBed: "Number Of Bed",
    TimeInMinute: "Time in minute",
    CourseClassNo: "Course class No",
    CourseClassDetail: "Course Class Detail",
    Request: "Request",
    Confirm: "Confirm",
    Reject: "Reject",
    Close: "Close",
    StatusName: "Status Name",
    StatusMail: "Status Mail",
    CoursesRequest: "Courses Request",

    CourseRequests: "Course Requests",
    CourseRegistrations: "Course Registrations",
    Gender: "Gender",
    Male: "Male",
    FeMale: "FeMale",
    Comment: "Comment",
    Birthdate: "Birthdate",
    EmailSeparate: "Email separate by",
    ParentStatus: "Parent Status",
    AdmissionTests: "Admission tests",
    CourseClassTests: "Course class tests",
    Days: "Days",
    IntroductionAbout: "Introduction About",
    CommaSeperated: "Add Who should attend comma seperted",
    DocsAndHand: "Documentation and hand-outs",
    CourseModules: "Course modules",
    StatusComment: "Status Comment",
    SelectProposalTemplate: "Select Proposal Template",
    Body: "Body",
    Check: "Check",
    Amount: "Amount",
    IsPayed: "IS Payed",
    EducationDegreeTypes: "Education Degree Types",
    CourseFees: "Course fees",
    PracticalCategory: "Practical Category",
    AttachmentType: "Attachment Type",
    DailyFees: "Daily Fees (USD)",
    ParentCategory: "Parent Category",
    UpdateImage: "Update Image",
    RemoveImage: "Remove Image",
    RevisionDate: "Revision Date",
    RevisionNumber: "Revision Number",
    DocumentNumber: "Document Number",
    WorkEmail: "Work Email *",
    FirstName: "First Name *",
    MiddleName: "Middle Name *",
    LastName: "Last Name *",
    SuperviserEMail: "Superviser E-Mail *",
    Section: "Section *",
    AddNew: "Add New",
    Update: "Update",
    Item: "Item",
    NewPassNote: "Please enter your new password",
    Characters: "Characters",
    ContainsNumber: "Contains Number",
    ContainsUppercase: "Contains Uppercase",
    ContainsSpecialCharacter: "Contains Special Character",
    PercMark: "Percentage Of Trainee Marks",
    Single: "Single",
    Double: "Double",
    Triple: "Triple",
    RoomPrice: "Room Price",
    AddInstructor: "Add Instructor",
    ContactPersonEmail: "Contact person email *",
    ContactPersonName: "Contact person name *",
    ContactPersonPhone: "Contact Person Phone *",
    ProposalTitle: "Proposal Title",
    ShowWithAnswers: "Show with answers",
    RecoverYourPassword: "Recover your password",
    RecPasswordNote: "Please enter your email address and we'll send you verify code to reset your password.",
    SendCode: "Send Code",
    BackToLogin: "Back To Login",
    AnnualPlanCode: "Annual Plan Code",
    AssignInstructorToMark: "Assign Instructor To mark",
    ChooseCategoryFoQuestion: "Choose Category to get its question",
    CoursesResult: "Courses Result",
    YourAddmissionTestDegree: "your addmission test degree",
    PassportAttachment: "Passport Attachment",
    VisaOnArrival: "Visa On Arrival",
    VisaProofAttachment: "Visa Proof Attachment",
    FlightTicketAttachment: "Flight Ticket Attachment",
    PleaseProv: "Please wait until approve your visa",
    PleaseProvReg: "Please wait until approve registration",
    PleaseProvSubmit: "please wait until review your submit data",
    PleaseUploadVisaProof: "Please Upload Visa proof",
    About: "About",
    DiplomaCode: "Diploma code",
    Objectives: "Learning Objectives",
    Prerequisite: "Prerequisite",
    CourseContent: "Course content",
    CourseImage: "Course Image",
    InstructorServices: "Instructor services",
    InstructorFee: "Instructor fee per day for the delivery of the courses",
    FeePerDay: "Fee per day",
    OfDays: "# Of Days",
    OfCourses: "# Of Courses",
    SubTotal: "sub total",
    InstructorFeeReport: "Instructor fee per day for courses' preparation and report",
    DailySubsistence: "Daily Subsistence Allowance (DSA)2",
    Passwordchangedsuccessfully: "Password changed successfully",
    ConfirmationDone: "Confirmation Done",
    Done: "Done",
    DonWronge: "Wrong",
    RejectedDone: "Rejected Done ",
    Mailissentsuccessfully: "Mail is sent successfully ",
    TotalEvaluationMeanPercentagemustbelessthan100: "Tota lEvaluation Mean Percentage must be less than 100% ",
    TotalExamPercentagemustbe100: "Total Exam Percentage must be  100% ",
    Theselectedrecordwassuccessfullydeleted: "The selected record was successfully deleted",
    PleaseEnterAllQuestionWeight: "Please Enter All Question Weight",
    PleaseEnterAllQuestionTime: "Please Enter All Question time",
    CourseFeeChargedToParticipantis: "Course Fee Charged To Participant is",
    Yourrequestsubmittedsuccessfully: "Your request submitted successfully",
    Unexpectederrorpleasetryagain: "Unexpected error please try again",
    thereareaproblem: "there are aproblem",
    MarkAllAsReadisDoneSuccessfully: "Mark All As Read is Done Successfully",
    MarkAsReadisDoneSuccessfully: "Mark  As Read is Done Successfully",
    PleaseaddallrequiredcontactinfoEmailMobile: "Please add all required contact info Email ,Mobile",
    PleaseaddallrequiredcontactinfoEmailWorkEmailMobile: "Please add all required contact info Email ,WorkEmail,Mobile",
    PleaseaddallrequiredcontactinfoEmailWorkEmailMobileFromContact: "Please add all required contact info Email ,WorkEmail,Mobile From Contact",
    PleaseaddallrequiredcontactinfoWorkEmail: "Please add all required contact info Work Email ",
    datasaveSuccessfully: "data save Successfully",
    ExamIsMarkedSuccessfully: "Exam Is Marked Successfully",
    registrationSuccessfulandyourrequestunderreview: "registration Successful and your request under review",
    DSAweekends: "DSA weekends",
    ClassRoomFees: "classroom operating fees at UATS",
    Travel: "Travel",
    AirTicket: "Air ticket",
    CostPerTicket: "Cost per ticket",
    OfTickets: "# of tickets",
    TerminalAllowance: "Terminal Allowance",
    FeePerTrainee: "Fee per trainee",
    OfTrainee: "# Of Trainee",
    HostingFees: "Hosting fees",
    TabletOrHandout: "Tablet Or Handout",
    Transportation: "transportation",
    CoursePerTrainee: "Course per trainee",
    InstructorsOfThatCourse: "Instructors Of That Course",
    Publish: "Publish",
    Unacceptable: "Unacceptable",
    Poor: "Poor",
    Acceptable: "Acceptable",
    VeryGood: "Very Good",
    Excellent: "Excellent",
    VeryPoor: "Very Poor",
    Good: "Good",
    Fair: "Fair",
    ConfirmAttended: "Confirm Attended",
    PracticalForTrainee: "Practical for trainee",
    MailType1: "Instructor Confirm course assign",
    MailType2: "Course class Start Alert",
    MailType3: "Training class change",
    MailType4: "New Exam",
    MailType5: "Assessment Exam",
    MailType6: "Invoice for course",
    MailType7: "Trainee pay request",
    MailType8: "Instractur Signup",
    MailType9: "Instractur Activation",
    MailType10: "Course request Confirmation",
    ByExams: "By exams",
    ByCourses: "By Courses",
    IsAttended: "Is Attended",
    StartAssessment: "Start Assessment",
    InstructorConfirm: "Instructor Confirm",
    CoordinatorConfirm: "Coordinator Confirm",
    Published: "Published",
    NotPublished: "Not Published",
    Main: "Main",
    Modules: "Modules",
    Material: "Material",
    Cost: "Cost",
    NewEvaluationMean: "New Evaluation Mean",
    AddEvaluationMean: "Add Evaluation Mean",
    AnnualPlanNum: "Annual Plan Num",
    TrainingRoom: "Training Room",
    MailStatusNot: "Their is no Mail Template to this status",
    SubmitSendPorposal: "Submit & Send Porposal",
    OnArrival: "OnArrival",
    SubmitAnswers: "Submit Answers",
    CourseExamName: "Course Exam Name",
    Previous: "previous",
    Next: "next",
    ThankFeadBack: "Thank you for your feedback, waiting to see you again",
    TraineePass: "Trainee pass",
    SubmitDegrees: "Submit degrees",
    TraineeMarks: "Trainee marks",
    Areyousureyouwantdeletethisrecord: "Are you sure you want delete this record",
    ThisContactAlreadyExists: "This Contact Already Exists",
    ThisareaAlreadyExists: "This area Already Exists",
    ThissectorAlreadyExists: "This sector Already Exists",
    ThisEducationDegreeAlreadyExists: "This Education Degree Already Exists",
    ThisLanguageAlreadyExists: "This Language Already Exists",
    fromgoogle: "fromgoogle",
    Areyousureyouwantconfirmthisevent: "Are you sure you want confirm this event",
    pleasecompletemandatorydataandatleastoneofeachdatalistandmakesurethatyourcontactcontainyouremail: "please complete mandatory data, and at least one of each data list,and make sure that your contact contain your email",
    Areyousureyouwantimportholidayforyear: "Are you sure you want import holiday for year",
    therearenoanswersforthisquestion: "there are no answers for this question",
    PracticalEvaluation: "Practical Evaluation",
    PrintExamAnswer: "Print exam answer",
    SessionTable: "Session Table",
    NewQuestion: "New Question",
    Show: "Show",
    ShowExamWithAnswer: "Show exam with answer",
    Exams: "Exams",
    AllExams: "All Exams",
    ReAssessment: "Re-Assessment",
    SaveChange: "Save Change",
    MustSelectModule: "You must select module first by click on it to can view and add material",
    FullMark: "Full Mark",
    TraineeMark: "Trainee Mark",
    RequestAtYourLocaion: "Request at your locaion",
    CoursePDF: "Download Course Profile in pdf",
    TraineeInfo: "Trainee Info",
    TraineeVisaInfo: "trainee Visa Info",
    AcceptTerms: "I accept the terms & conditions",
    NotFound: "not found",
    LoginInfo: "Login Info",
    OrganizationAdressInfo: "Organization Adress info",
    Address1: "Address1",
    Address2: "Address2",
    City: "City",
    ZipCode: "ZipCode",
    PleasAddWorkMail: "please add work mail from add contact",
    PersonalMail: "Personal Mail *",
    PreferdEmail: "Preferd E-mail *",
    AddCourse: "Add Course",
    AddAttachment: "Add Attachment",
    Attachment: "Attachment",
    UpdateAttachment: "Update Attachment",
    RemoveAttachment: "Remove Attachment",
    MainInfo: "Main Info",
    Contact: "Contact",
    NewContact: "New Contact",
    NewAttachment: "New Attachment",
    Education: "Education",
    NewEducationDegree: "New Education Degree",
    AddEducationDegree: "Add Education Degree",
    CoursesDeliver: "Courses deliver",
    CoursesObtained: "Courses obtained",
    Attachments: "Attachments",
    WelcomeBackPleasLogin: "Welcome back, please login to your account",
    WorkExperience: "Work Experience",
    MultiChoose: "Multi Choose",
    Text: "Text",
    TrueFalse: "True/False",
    CourseClassWithID: "Course Class  with id",
    YouHaveRegisterSuccessfully: "You have register successfully",
    YouHaveRegisterSuccessfullyWithCode: "you have register successfully with register code",
    FollowRegistrationByClick: "you can follow registration by click",
    AlreadyRegister: "You are already register",
    UploadCvs: "you can upload any document like CVs",
    AlreadyAssignToInstructor: "already assign to Instructor",
    FullyReady: "Are you fully ready ( Confirm / Reject )",
    AchievementsAndActivities: "Achievements And Activities",
    PaymentSwiftCheck: "please check invoice in mail then Upload Payment swift code",
    ThanksForPayment: "Thank you for payment , please wait for travel Arrangements",
    ThanksForApprove: "thank you for approve wait to send you invoice",
    ThisNameWillUseInCertificate: "This name will use in certificate",
    Signup: "Sign up",
    RememperMe: "Remember Me",
    ForgotePassword: "Forgote Password",
    FinancialProposal: "Financial Proposal",
    Accept: "Accept",
    Decline: "Decline",
    SendYouOtherProposal: "Please wait until send you other proposal",
    Accommodation: "Accommodation",
    Pleaseentervaliddetails: "Please enter valid details",
    Paymentreceivedsuccessfully: "Payment received successfully",
    ImportedCourseAddScuessfully: "Imported Course Add Scuessfully",
    ImportedEmailAddScuessfully: "Imported emails Add Scuessfully",

    SuccessuploadyourAttachment: "Success upload  your Attachment",
    MouduleImportSuccessfully: "Moudule Import Successfully",
    alreadyassigntoInstructor: "already assign to Instructor",
    Sessionmustbewithencourseclassdates: "Session must be withen course class dates",
    TraineeDataSavedSuccessfully: "Trainee Data Saved Successfully",
    TheselectedEventwassuccessfullyConfirmed: "The selected Event was successfully Confirmed",
    errorinusernameorpassword: "error in user name or password",
    Youarealreadyloggedin: "You are already logged in",
    cantdeletedthisuseryoucansetitasinactive: "can't deleted this user you can set it as inactive",
    RequireVisa: "Require Visa",
    Clear: "Clear",
    Diploma: "Diploma",
    TraineeSelectCourse: "Trainee select this course as one of this diploma",
    DownloadVisaApprove: "download visa approve",
    DownloadInvitationLetter: "download invitation letter",
    DownloadPlacementLetter: "download placement letter",
    InvoiceAttachement: "Invoice Attachement",
    ConfirmPayAttachement: "Confirm Pay Attachement",
    PleaseUploadPaymentProof: "Please Upload Payment proof",
    DownloadAttachement: "Download attachement",
    InstructorReviews: "Instructor Reviews",
    CourseQualifies: "this course qualifies you for one of these diploma",
    InvitationAndDocument: "invitation & placement document",
    ImportFromGoogle: "Import From Google",
    Weekends: "Weekends",
    FromYear: "From Year",
    ToYear: "To Year",
    Copy: "Copy",
    CoursesRegistered: "Courses Registered",
    InSystemFrom: "In System From",
    Records: "Records",
    View: "View",
    ViewDetail: "View Detail",
    InstructorReviewsAnswer: "Instructor Reviews Answer",
    Success: "Success",
    UploadSuccess: "Upload Success",
    ImportedSuccess: "Imported Success",
    Deletedrecord: "Deletedrecord",
    Assign: "Assign",
    InstructorAssessmentResult: "Instructor Assessment Result",
    FeedbackQuestionnaire: "Feedback Questionnaire",
    FeedbackQuestionnaireAnswer: "Feedback Questionnaire Answer",
    TraineeAttendanceSheet: "Trainee Attendance Sheet",
    DailyAttendanceSheet: "Daily Attendance Sheet",
    InstructorAttendanceSheet: "Instructor Attendance Sheet",
    TrainingCourseStatistic: "Training Course Statistic",
    CoursePractical: "Course Practical",
    CourseClassEvaluationMean: "Course Class Evaluation Mean",
    CourseRegistrationInvoice: "Course Registration Invoice",
    CourseRequestInvoice: "Course Request Invoice",
    RegistrationInvitationLetter: "Registration Invitation Letter",
    RegistrationPlacementLetter: "Registration Placement Letter",
    RequestInvitationLetter: "Request Invitation Letter",
    RequestPlacementLetter: "Request Placement Letter",
    TrainingOrder: "Training Order",
    CourseClassStatisticCharts: "Course Class Statistic Charts",
    CreateAccount: "Create Account",
    PleaseChooseAccountType: "Please Choose account Type",

    ChangePassword: "Change Password",
    Logout: "Logout",
    UsernameRequired: "Username *",
    ValidEmail: "Must enter valid email to verify it",
    NewPassword: "New Password",
    OldPassword: "Old Password",
    Password: "Password",
    PasswordRequired: "Password *",
    ConfirmPassword: "Confirm Password",
    AdressInfo: "Adress info",
    PersonalInfo: "Personal info",
    NationalityRequired: "Nationality *",

    ProfileImage: "Profile Image",
    PassportNo: "Passport No",
    JobInfo: "Job info",
    Mobile: "Mobile *",
    Filter: "Filter",
    Location: "Location",
    Evaluation: "Evaluation",
    NoOfAids: "No Of Aids",
    Profit: "Profit",
    TrainingFees: "Training Fees",
    AddMaterial: "Add Material",
    ImportModule: "Import Module",
    Add: "Add",
    EditModule: "Edit Module",
    ViewMaterial: "View Material",
    StatusHistory: "Status History",
    MailHistory: "Mail History",
    CourseFeeToParticipant: "Course Fee To Participant",
    SendMail: "Send Mail",
    Certificate: "Certificate",
    Mail: "Mail *",
    Phone: "Phone *",
    OrderNumber: "Order Number",
    Icon: "Icon",
    EmbassyAddress: "Embassy Address",
    EmbassyCity: "Embassy City",
    EmbassyPhone: "Embassy Phone",
    DescreptionVisa: "Descreption Visa",
    TargetUrl: "Target Url",
    Keyword: "Key word",
    Exercises: "Exercises",
    Save: "Save",
    NewMessage: "New Message",
    NewCourse: "New Course",
    NewArea: "New Area",
    NewSector: "New Sector",
    NewFacility: "New Facility",
    TraineeSchedule: "Trainee Schedule",
    Advertisement: "Advertisement",
    InstructorSchedule: "Instructor Schedule",
    TraineeExam: "Trainee Exam",
    MarkTraineeExam: "Mark Trainee Exam",
    ReviewAnswer: "Review Answer",
    AvailableFeedback: "Available Feedback",
    Assessment: "Assessment",
    AssessmentAnswer: "Assessment Answer",
    PracticalEvaluationAnswer: "Practical Evaluation Answer",
    CourseMaterialDetail: "Course Material Detail",
    ConfirmRegistration: "Confirm Registration",
    ConfirmCustomRegistration: "Confirm Custom Registration",
    ConfirmRequestRegistration: "Confirm Request Registration",
    RegistrationStatus: "Registration Status",
    CourseDetail: "Course Detail",
    TrackAddEdit: "Track-Add/Edit",
    Track: "Deploma",
    CourseRequestAddEdit: "Course Request-Add/Edit",
    CourseRequestCosting: "Course Request Costing",
    UpcomingCourse: "Upcoming Course",
    CourseList: "Course List",
    CourseRegistrationAddEdit: "Course Registration-Add/Edit",
    CourseAddEdit: "Course-Add/Edit",
    CourseExamAddEdit: "Course Exam-Add/Edit",
    Data: "Data",
    InstructorAddEdit: "Instructor/Add-Edit",
    InstructorHistory: "Instructor History",
    OrganizationAddEdit: "Organization-Add/Edit",
    OrganizationHistory: "Organization History",
    TraineeCourses: "Trainee Courses",
    TraineeHistory: "Trainee History",
    TraineeAddEdit: "Trainee-Add/Edit",
    user: "user",
    ExamQuestionCategory: "Exam Question Category",
    Room: "Room",
    RoomAddEdit: "Room-Add/Edit",
    RoomFacility: "Room Facility",
    ListOfCourses: "List Of Courses",
    ListOfModule: "List Of Module",
    QuestionBankAddEdit: "Question Bank-Add/Edit",
    CourseFeedbackQuestion: "Course Feedback Question",
    ListOfCategory: "List Of Category",
    CourseFeedbackQuestionAddEdit: "Course Feedback Question Add/Edit",
    AssessmentQuestionAddEdit: "Assessment Question Add/Edit",
    PracticalEvaluationQuestionAddEdit: "Practical Evaluation Question Add/Edit",
    CoursePracticalQuestion: "Course Practical Question",
    CoursePracticalQuestionAddEdit: "Course Practical Question Add/Edit",
    ClassRoomAddEdit: "Class Room-Add/Edit",
    InstructorStatus: "Instructor Status",
    Dialogwarning: "Dialog warning",
    setinstructorasnonew: "set instructor as no new",
    CompleteData: "Complete Data",
    CourseFeedbackAddEdit: "Course Feedback Add/Edit",
    InstructorAssessmentAddEdit: "Instructor Assessment Add/Edit",
    ProgramDetail: "Program Detail",
    AvailableExam: "Available Exam",
    ExamAnswer: "Exam Answer",
    AnnualPlanCosting: "Annual Plan Costing",
    CourseClassAddEdit: "course Class add/Edit",
    ExamAddEdit: "Exam add/Edit",
    CustomizedProposal: "Customized Proposal",
    GeneralImageForMail: "General Image For Mail",
    TraineeExamWithAnswer: "Trainee Exam With Answer",
    RegisterConfirmation: "Register Confirmation",
    InstructorConfirmation: "Instructor Confirmation",
    PracticalDegree: "Practical Degree",
    TraineeCoursesInstructor: "Trainee Courses Instructor",
    TraineePractical: "Trainee Practical",
    CourseDetailReport: "Course Detail Report",
    UpcomingCourseDetailReport: "Upcoming Course Detail Report",
    CourseRegistrationInvoiceReport: "Course Registration Invoice Report",


    CourseRequestInvoiceReport: "Course Request Invoice Report",
    DiplomaDetailReport: "Diploma Detail Report",
    CertificateReport: "Certificate Report",
    InstructorAssessmentAnswerReport: "Instructor Assessment Answer Report",
    CourseFeedbackReport: "Course Feedback Report",
    TraineeAttendanceReport: "Trainee Attendance Report",
    InstructorLogInReport: "Instructor Log-In Report",
    DailyAttendanceReport: "Daily Attendance Report",
    AuthorizationOfInstruction: "Authorization Of Instruction",
    RegistrationForm: "Registration Form",
    InstructorAssessmentReport: "Instructor Assessment Report",
    CheckList: "Check List",
    CourseExamAnswer: "Course Exam Answer",
    TraininingCourseStatistic: "Trainining Course Statistic",
    FinancialPorposal: "Financial Porposal",
    FinalEvaluation: "Final Evaluation",
    DialyFollowUpTrainingEvaluation: "Dialy FollowUp Training Evaluation",
    SingleCourseAdvertV1: "Single Course AdvertV1",
    InstructorProfile: "Instructor Profile",
    TraineeProfile: "Trainee Profile",
    OrganizationProfile: "Organization Profile",
    AnnualPlanGridView: "Annual Plan GridView",
    ClassRoomSchedule: "Class Room Schedule",
    TraineeRequestForm: "Trainee Request Form",
    OrganizationRequestForm: "Organization Request Form",
    CourseClassEvaluationMeanStatistic: "Course Class Evaluation Mean Statistic",
    CheckCode: "Check Code",


    CourseProfile: "Course Profile",
    Total: "Total",
    CourseDurationInDay: "Course Duration In Day",
    DailyRate: "Daily Rate (USD)",
    CoursesToDeliver: "Courses to deliver",
    Seperator: "Seperator",
    AnalysisandReports: "Analysis and Reports",
    Checkyouragencyperformanceandtrainingstatus: "Check your agency performance and training status",
    Manageannualplanwithastrategicagendaandcourseplans: "Manage annual plan with a strategic agenda and course plans",
    Managecoursecatalogwiththeirdetailedinformation: "Manage course catalog with their detailed information.",

    CSVTemplate: "CSV Template",
    ImportCSVTemplate: "Import from CSV Template",
    UPDATEWEEKEND: "UPDATE WEEKEND",
    IsWeekend: "Is Weekend",
    Day: "Day",
    ImportFromCSV: "Import from CSV",
    UserType: "User Type",
    ImportEmails: "Import Emails",
    ExportCSV:"Export CSV",
    Role: "Role",
    IsActive: "Is Active",
    CustomMail: "Custom Mail",
    Filterannualplan: "Filter annual plan",
    template: "template",
    LoginNote: "if you have an account please log in, if not please join with us by signup",
    PreviousQuestion: "Previous Question",
    NextQuestion: "Next Question",
    Areyousureyouwantsubmitanswer: "Are you sure you want to submit answers",
    TraineeEmails: "Trainee Emails",
    LogActions: "Log Actions",
    LogActionDescription: "Description",
    SectionName: "Section Name",
    CreatedDate: "Created Date",
    FeedbackAction: "Feedback Action",
    FeedbackActionEdit: "Feedback Action View",
    InstructorsFeedBack: "Instructors FeedBack",
    InstructorFeedBackAnswer: "Instructor FeedBack Answer",
    CourseInstructorFeedback: "Course Instructor Feedback",
    AvailableInstructorReview: "Available Instructor Feedback",
    ReviewInstructorAnswer: "Review Instructor Answer",
    NotDeleted :"Can't Deleted",
    RelatedCoures :"this catalog course has course class and trainee",
    ActionType:"Action Type",
  },
  ar: {
    ActionType :"نوع التغيير",
    ExportCSV:"تصدير الى ملف CSV",
    NotDeleted :"لا يمكن الحذف",
    RelatedCoures :"هذا الكورس تم تنفيذه و لديه متدربين",
    ReviewInstructorAnswer: "اجوبة تقيم المدرس",
    AvailableInstructorReview: "التقيمات المتاحة",
    CourseInstructorFeedback: "تقيم المدرس",
    InstructorFeedBackAnswer: "اجوبة تقيم المدرس",
    InstructorsFeedBack: "تقيمات المدرس",
    TraineeEmails: "ايميلات المتدربين",
    Areyousureyouwantsubmitanswer: "متأكد انك تريد تأكيد الاجابات",
    NextQuestion: "السؤال التالي",
    PreviousQuestion: "السؤال السابق",
    LoginNote: "إذا كان لديك حساب يرجى تسجيل الدخول ، وإذا لم يكن كذلك ، يرجى الانضمام إلينا عن طريق التسجيل",
    CustomMail: "بريد مخصص",
    Filterannualplan: "تصفية الخطة السنوية",
    template: "نموذج",
    IsActive: "نشط؟",
    Role: "دور",
    ImportEmails: "استيراد بريد",
    UserType: "نوع المستخدم",
    FileExport:"اختار الملف لتصديره CSV",
    ImportFromCSV: "استيراد من ملف csv",
    AnalysisandReports: " التحاليل والتقارير ",
    Checkyouragencyperformanceandtrainingstatus: " تحقق من أداء وكالتك وحالة التدريب ",
    Manageannualplanwithastrategicagendaandcourseplans: "إدارة الخطة السنوية مع جدول الأعمال الاستراتيجي وخطط الدورة",
    Managecoursecatalogwiththeirdetailedinformation: "إدارة كتالوج الدورة بمعلوماتها التفصيلية.",
    Export: "استخراج",
    CSVTemplate: "نموذج Csv",
    ImportCSVTemplate: "استيراد نموذج ك Csv",
    UPDATEWEEKEND: "تحديث عطلة نهاية الأسبوع",
    IsWeekend: "هل عطلة نهاية الأسبوع",
    Day: " اليوم  ",
    Seperator: "فاصل",
    CoursesToDeliver: "مقررات للتسليم",
    DailyRate: "تقييم يومي",
    CourseDurationInDay: "مدة المقرر بالايام",
    Total: "الاجمالي",
    CourseProfile: "ملف المقرر",
    CourseRequestInvoiceReport: "تقرير فاتورة طلب المقرر ",
    DiplomaDetailReport: "تقرير تفصيلي للدبلومة",
    CertificateReport: "تقرير الشهادة",
    InstructorAssessmentAnswerReport: "تقرير إجابة تقييم المعلم",
    CourseFeedbackReport: "تقرير تقييمات المقرر",
    TraineeAttendanceReport: "تقرير حضور متدرب",
    InstructorLogInReport: "تقرير تسجيل دخول المدرب",
    DailyAttendanceReport: "تقرير الحضور اليومي",
    RegistrationForm: "إستمارة تسجيل",
    InstructorAssessmentReport: "تقرير تقييم المدرب",
    CheckList: "قائمة تدقيق",
    CourseExamAnswer: "إجابة امتحان المقرر",
    TraininingCourseStatistic: "إحصائية الدورة التدريبية",
    FinancialPorposal: "عرض مالي",
    DialyFollowUpTrainingEvaluation: "متابعة تقييم التدريب اليومي",
    SingleCourseAdvertV1: "إعلان مقرر دراسي واحد",
    InstructorProfile: "الملف الشخصي للمدرب",
    TraineeProfile: "الملف الشخصي للمتدرب",
    OrganizationProfile: "الملف الشخصي للمؤسسة",
    AnnualPlanGridView: "الخطة السنوية",
    TraineeRequestForm: "استمارة طلب متدرب",
    OrganizationRequestForm: "نموذج طلب المنظمة",
    CourseClassEvaluationMeanStatistic: "تقييم فئة المقرر: إحصائي",
    CheckCode: "التحقق من الشفرة",
    LockScreen: "اقفل الشاشة",
    ComingSoon: "قريبا",
    CourseRegistrationInvoiceReport: "تقرير فاتورة تسجيل مقرر",
    UpcomingCourseDetailReport: "تقرير تفاصيل المقررات القادمة",
    CourseDetailReport: "تقرير تفاصيل المقرر",
    TraineePractical: "العملي الخاص بالمتدرب",
    TraineeCoursesInstructor: "مقررات المدرب",
    PracticalDegree: "درجات العملي",
    InstructorConfirmation: "تأكيد المدرب",
    RegisterConfirmation: "تأكيد الحجز",
    TraineeExamWithAnswer: "امتحان المتدرب مع الإجابة",
    GeneralImageForMail: "الصورة العامة للبريد",
    CustomizedProposal: "تصميم عرض",
    ExamAddEdit: "أضافة/تعديل امتحان",
    CourseClassAddEdit: "أضافة/تعديل برنامج فعلي",
    AnnualPlanCosting: "تكلفة الخطة",
    ExamAnswer: "حل الامتحان",
    AvailableExam: "امتحانات متاحة",
    ProgramDetail: "تفاضيل البرنامج",
    InstructorAssessmentAddEdit: "أضافة تقييم مقرر دراسي",
    CourseFeedbackAddEdit: "أضافة/تعديل تقييم البرنامج الدراسي",
    AssessmentType: "نوع التقييم",
    Dialogwarning: "رسالة تحذرية",
    setinstructorasnonew: "تعيين المدرب على أنه ليس جديدًا",
    CompleteData: " استكمال البيانات",
    InstructorStatus: "حالة المدرب",
    ClassRoomAddEdit: "أضافة/تعديل غرفة التدريس",
    CoursePracticalQuestionAddEdit: "أضافة/تعديل سؤال المقرر العملي",
    CoursePracticalQuestion: "سؤال المقرر العملي",
    PracticalEvaluationQuestionAddEdit: "أضافة/تعديل سؤال تقييم العملي",
    AssessmentQuestionAddEdit: "أضافة/تعديل سؤال التقييم",
    CourseFeedbackQuestionAddEdit: "أضافة/تعديل سؤال التقييم",
    ListOfCategory: "قائمة الفئات",
    CourseFeedbackQuestion: "سؤال تقييم المقرر الدراسي",
    QuestionBankAddEdit: "أضافة/تعديل سؤال",
    ListOfModule: "قائمة الوحدات",
    ListOfCourses: "قائمة المقررات",
    Question: "سؤال",
    RoomFacility: "مرفق الغرفة",
    RoomAddEdit: "أضافة/تعديل غرفة",
    Room: "غرفة",
    ExamQuestionCategory: "فئة سؤال الامتحان",
    user: "مستخدم",
    TraineeAddEdit: "اضافة/تعديل متدرب",
    TraineeHistory: "تاريخ المتدرب",
    TraineeCourses: "المقررات الدراسية للمتدرب",
    OrganizationHistory: "تاريخ المؤسسة",
    OrganizationAddEdit: "أضافة/تعديل مؤسسة",
    InstructorHistory: "تاريخ المدرب",
    InstructorAddEdit: "اضافة/تعديل مدرب",
    Data: "البيانات",
    CourseExamAddEdit: "اضافة/تعديل امتحان المقرر",
    CourseAddEdit: "اضافة/تعديل مقرر",
    CourseRegistrationAddEdit: "اضافة/تعديل تسجيل مقرر",
    CourseList: "قائمة المقررات",
    UpcomingCourse: "المقررات القادمة",
    CourseRequestCosting: "تكلفة طلب التسجيل",
    CourseRequestAddEdit: "اضافة /تعديل طلب تسجيل",
    Track: "دبلومة",
    TrackAddEdit: "اضافة وتعديل دبلومة",
    CourseDetail: "تفاصيل البرنامج الدراسي",
    RegistrationStatus: "حالة التسجيل",
    ConfirmRequestRegistration: "تأكيد طلب التسجيل",
    ConfirmCustomRegistration: "تأكيد التسجيل المخصص",
    ConfirmRegistration: "تأكيد التسجيل",
    CourseMaterialDetail: "تفاصيل مواد المقرر الدراسي",
    PracticalEvaluationAnswer: "إجابة التقييم العملي",
    AssessmentAnswer: "اجابات التقييم",
    Assessment: "تقييم",
    AvailableFeedback: "التقييم المتاح",
    ReviewAnswer: "مراجعة الاجابات",
    MarkTraineeExam: "تصحيح امتحانات المتدربين",
    InstructorMarkExam: "تصحيح المدرب الامتحانات",
    TraineeExam: "امتحانات المتدرب",
    InstructorSchedule: "جدول المدرب",
    Advertisement: "",
    TraineeSchedule: "جدول المتدرب",
    NewFacility: "مرفق جديد",
    NewSector: "قطاع جديد",
    NewArea: "منطقة جديدة",
    NewCourse: "تدريب جديد",
    NewMessage: "رسالة جديدة",
    Save: "حفظ",
    Exercises: "اختبارات",
    Keyword: "الكلمة الرئيسية",
    TargetUrl: "الرابط",
    DescreptionVisa: "وصف التأشيرة",
    EmbassyCity: "مدينة السفارات",
    EmbassyPhone: "تليفون السفارات",
    EmbassyAddress: "عنوان السفارة",
    Icon: "أيقونة",
    OrderNumber: "رقم الأمر",
    Mail: "البريد *",
    Phone: "هاتف *",
    Certificate: "الشهادة",
    SendMail: "ارسال البريد",
    CourseFeeToParticipant: "الرسوم",
    MailHistory: "البريد السابق",
    StatusHistory: "الحالات السابقة",
    ViewMaterial: "مشاهدة المواد",
    EditModule: "تعديل مادة",
    Add: "أضافة",
    ImportModule: "وحدة الاستيراد السابقة",
    AddMaterial: "اضافة مادة",
    TrainingFees: "رسوم التدريب",
    Profit: "الربح",
    NoOfAids: "العدد",
    Evaluation: "التقييم",
    Location: "موقع التدريب",
    Filter: "بحث",
    Mobile: "التليفون المحمول *",
    JobInfo: "بيانات العمل",
    PassportNo: "رقم جواز السفر",
    ProfileImage: "صورة الملف الشخصي",
    Nationality: "الجنسية",
    NationalityRequired: "الجنسية *",
    PersonalInfo: "البيانات الشخصية",
    AdressInfo: "بيانات العنوان",
    ConfirmPassword: "تأكيد الرقم السري",
    PasswordRequired: "الرقم السري *",
    Password: "الرقم السري",
    NewPassword: "الرقم السري الجديد",
    OldPassword: "الرقم السري القديم",
    ValidEmail: "يجب إدخال بريد إلكتروني صالح للتحقق منه",
    UsernameRequired: "اسم المستخدم *",
    Logout: "تسجيل خروج",
    ChangePassword: "تغيير كلمة المرور",
    Profile: "الملف الشخصي",
    PleaseChooseAccountType: "اختار نوع الحساب",
    CreateAccount: "انشاء حساب",
    InstructorAssessmentResult: "نتيجة تقييم المدرب",
    FeedbackQuestionnaire: "استبيان التقييم",
    FeedbackQuestionnaireAnswer: "اجابات التقييم",
    TraineeAttendanceSheet: "غياب المتدربين",
    DailyAttendanceSheet: "الغياب اليومي",
    InstructorAttendanceSheet: "غياب المدرب",
    AuthorizationOfInstruction: "أذن التدريب",
    TrainingCourseStatistic: "احصائيات المقررات الدراسية",
    CoursePractical: "المقرر العملي",
    FinalEvaluation: "التقييم النهائي",
    ClassRoomSchedule: "جدول الفصول الدراسية",
    CourseClassEvaluationMean: "تقييمات المقرر الدراسي",
    CourseRegistrationInvoice: "فاتورة تسجيل المقرر الدراسي",
    CourseRequestInvoice: "فاتورة طلب تسجيل في مقرر دراسي",
    RegistrationInvitationLetter: "خطاب دعوة التسجيل",
    RegistrationPlacementLetter: "خطاب التنسيب للتسجيل",
    RequestInvitationLetter: "طلب خطاب دعوة",
    RequestPlacementLetter: "خطاب طلب التنسيب",
    TrainingOrder: "المقررات الفعلية",
    CourseClassStatisticCharts: "الرسوم البيانية الإحصائية لفئة المقرر الدراسي",
    Success: "تمت",
    Deletedrecord: "مسح السجل",
    UploadSuccess: "تم الرفع بنجاح ",
    Assign: "تعيين",
    ImportedSuccess: "تم الاستيراد بنجاح ",
    InstructorReviewsAnswer: "إجابة تعليقات المعلم",
    ViewDetail: "مشاهدة التفاصيل",
    View: "مشاهدة",
    Reports: "التقارير",
    Records: "السجلات",
    InSystemFrom: "في النظام من",
    CoursesRegistered: "مقررات دراسية مسجلة",
    Copy: "نسخ",
    FromYear: "من سنة",
    ToYear: "الي سنة",
    Weekends: "عطلات نهاية الأسبوع",
    ImportFromGoogle: "استيراد من جوجل",
    InvitationAndDocument: "وثيقة الدعوة والتنسيب",
    CourseQualifies: "يؤهلك هذا المقرر للحصول على أحد هذه الدبلومات",
    InstructorReviews: "مراجعات المدرب",
    DownloadAttachement: "تحميل المرفق",
    PleaseUploadPaymentProof: "يرجى تحميل إثبات الدفع",
    ConfirmPayAttachement: "تأكيد مرفق الدفع",
    InvoiceAttachement: "مرفق الفاتورة",
    DownloadPlacementLetter: "تحميل خطاب التنسيب",
    DownloadInvitationLetter: "تحميل خطاب الدعوة",
    DownloadVisaApprove: " تحميل موافقة التأشيرة",
    TraineeSelectCourse: "يختار المتدرب هذا مقرر دراسي كواحدة من هذه الدبلومة",
    Diploma: "دبلومة",
    Clear: "مسح",
    RequireVisa: "تتطلب تأشيرة",
    Pleaseentervaliddetails: "الرجاء إدخال تفاصيل صحيحة",
    Paymentreceivedsuccessfully: "تم استلام الدفعة بنجاح",
    Theselectedrecordwassuccessfullydeleted: "تم حذف السجل المحدد بنجاح",
    ImportedCourseAddScuessfully: "تم إضافة الدورة التي تم استيرادها بنجاح",
    ImportedEmailAddScuessfully: "تم إضافة البريد التي تم استيرادها بنجاح",
    SuccessuploadyourAttachment: "تم بنجاح تحميل المرفق الخاص بك",
    MouduleImportSuccessfully: "تم استيراد الوحدة  بنجاح",
    alreadyassigntoInstructor: "تم تعيينه بالفعل للمدرب",
    Sessionmustbewithencourseclassdates: "يجب أن تكون الجلسة ضمن مواعيد الفصل الدراسي",
    TraineeDataSavedSuccessfully: "تم حفظ بيانات المتدرب بنجاح",
    TheselectedEventwassuccessfullyConfirmed: "تم تأكيد الحدث المحدد بنجاح",
    errorinusernameorpassword: " خطأ في اسم المستخدم أو كلمة المرور",
    Youarealreadyloggedin: "انت بالفعل سجل دخول ",
    cantdeletedthisuseryoucansetitasinactive: "لا يمكن حذف هذا المستخدم ، يمكنك تعيينه على أنه غير نشط",
    Accommodation: "اقامة",
    SendYouOtherProposal: "يرجى الانتظار حتى نرسل لك اقتراح آخر",
    Decline: "رفض",
    Accept: "موافق",
    FinancialProposal: "عرض مالي",
    RememperMe: "تذكرني",
    ForgotPassword: "هل نسيت كلمة السر",
    Signup: "انشاء حساب",
    ThisNameWillUseInCertificate: "سيستخدم هذا الاسم في الشهادة",
    ThanksForApprove: "شكرا للموافقة ,قيد الانتظار لإرسال الفاتورة",
    ThanksForPayment: "شكرًا على الدفع ، يرجى انتظار ترتيبات السفر",
    PaymentSwiftCheck: "يرجى مراجعة الفاتورة بالبريد ثم تحميل كود سويفت للدفع",
    AchievementsAndActivities: "الانجازات والنشاطات",
    FullyReady: "هل أنت جاهز بالكامل (تأكيد / رفض)",
    AlreadyAssignToInstructor: "تم تعيينه بالفعل لمدرب",
    UploadCvs: "يمكنك تحميل أي وثيقة مثل السير الذاتية",
    AlreadyRegister: "You are already register",
    FollowRegistrationByClick: "يمكنك متابعة التسجيل عن طريق النقر",
    YouHaveRegisterSuccessfully: "لقد قمت بالتسجيل بنجاح",
    YouHaveRegisterSuccessfullyWithCode: "لقد قمت بالتسجيل بنجاح مع رمز التسجيل",

    CourseClassWithID: "التدريب الفعلي بالرقم التعريفي",
    MultiChoose: "اختيار من متعدد",
    Text: "نص",
    TrueFalse: "صح أو خطأ",
    WorkExperience: "خبرات العمل",
    WelcomeBackPleasLogin: "مرحبًا بك من جديد ، يرجى تسجيل الدخول إلى حسابك",
    Attachments: "المرفقات",
    CoursesDeliver: "البرامج التي تم حضورها",
    CoursesObtained: "البرامج التي تم الالتحاق بها",
    AddEducationDegree: "اضافة درجة تعليم",
    NewEducationDegree: "درجة تعليم جديدة",
    Education: "التعليم",
    NewAttachment: "مرفق جديد",
    NewContact: "تواصل جديد",
    Contact: "التواصل",
    MainInfo: "البيانات الرئيسية",
    RemoveAttachment: "مسح المرفق",
    UpdateAttachment: "تحديث المرفق",
    Attachment: "المرفق",
    AddAttachment: "اضافة مرفق",
    AddCourse: "اضافة مقرر دراسي",
    PreferdEmail: "البريد الشخصي المفضل",
    PersonalMail: " البريد الشخصي *",
    PleasAddWorkMail: "الرجاء إضافة بريد العمل من إضافة جهة اتصال",
    ZipCode: "الرمز البريدي",
    City: "المدينة",
    Address2: "العنوان الثاني",
    Address1: "العنوان الاول",
    OrganizationAdressInfo: "بيانات عنوان المؤسسة",
    LoginInfo: "بيانات تسجيل الدخول",
    NotFound: "غير موجود",
    Login: "تسجيل الدخول",
    AcceptTerms: "أوافق على الشروط والأحكام",
    TraineeVisaInfo: "معلومات تأشيرة المتدرب",
    TraineeInfo: "بيانات المتدرب",
    CoursePDF: "تحميل الملف التعريفي للمقرر ك pdf",
    RequestAtYourLocaion: "طلب في موقعك",
    TraineeMark: "درجة المتدرب",
    FullMark: "الدرجة الكلية",
    MustSelectModule: "يجب عليك تحديد الوحدة أولاً عن طريق النقر عليها لتتمكن من عرض المواد وإضافتها",
    SaveChange: "حفظ التغييرات",
    ReAssessment: "أعادة التقييم",
    AllExams: "كل الامتحانات",
    Exams: "الامتحانات",
    ShowExamWithAnswer: "مشاهدة الامتحان بالأجابات",
    Show: "مشاهدة",
    NewQuestion: "سؤال جديد",
    SessionTable: "جدول المحاضرات",
    PrintExamAnswer: "طباعة الاسئلة بالاجوبة",
    PracticalEvaluation: "تقييم العملي",
    Areyousureyouwantdeletethisrecord: "هل أنت متأكد أنك تريد حذف هذا السجل",
    ThisContactAlreadyExists: "هذا السجل موجود بالفعل",
    ThisareaAlreadyExists: "هذا المنطقة موجود بالفعل",
    ThissectorAlreadyExists: "هذا القسم موجود بالفعل",
    ThisEducationDegreeAlreadyExists: "هذا الدرجة العملية موجود بالفعل",
    ThisLanguageAlreadyExists: "هذا اللغة  موجود بالفعل",
    fromgoogle: "من جوجل",
    Areyousureyouwantimportholidayforyear: "هل أنت متأكد أنك تريد استيراد عطلة لمدة عام ",
    pleasecompletemandatorydataandatleastoneofeachdatalistandmakesurethatyourcontactcontainyouremail: "يرجى إكمال البيانات الإلزامية ، وواحد على الأقل من كل قائمة بيانات ، وتأكد من أن جهة الاتصال الخاصة بك تحتوي على بريدك الإلكتروني ",
    Areyousureyouwantconfirmthisevent: "هل أنت متأكد أنك تريد تأكيد هذا الحدث ",
    therearenoanswersforthisquestion: " لا توجد إجابات لهذا السؤال",
    TraineeMarks: " درجات المتدرب",
    SubmitDegrees: "تأكيد الدرجات",
    TraineePass: "نجاح الطالب",
    ThankFeadBack: "شكرا لك على ملاحظاتك ، في انتظار رؤيتك مرة أخرى",
    Next: "التالي",
    Previous: "السابق",
    CourseExam: "امتحان المقرر",
    SubmitAnswers: "تأكيد الاجابات",
    OnArrival: "عند الوصول",
    SubmitSendPorposal: "تأكيد الاقتراح وإرساله",
    MailStatusNot: "ليس لديهم قالب بريد لهذه الحالة",
    TrainingRoom: "غرفة التدريس",
    AnnualPlanNum: "عدد الخطط",
    AddEvaluationMean: "اضافة تقييم جديد",
    NewEvaluationMean: " تقييم جديد",
    Cost: "التكلفة",
    Material: "مواد",
    Modules: "الوحدات",
    Main: "الرئيسي",
    NotPublished: "غير منشور",
    Published: "منشور",
    CoordinatorConfirm: "تأكيد المنسق",
    InstructorConfirm: "تأكيد المدرب",
    StartAssessment: "بدأ التقييم",
    IsAttended: "تم الحضور",
    ByCourses: "بالمقرر الدراسي",
    ByExams: "بالامتحانات",
    MailType1: "تأكيد المدرب للانضمام لمقرر فعلي",
    MailType2: "تنبيه بداية المقرر الفعلي",
    MailType3: "تغيير في بيانات المقرر الفعلي",
    MailType4: "امتحان جديد",
    MailType5: "تقييم جديد",
    MailType6: "تقييم",
    MailType7: "فاتورة مقرر",
    MailType8: "دفع المتدرب للرسوم المقرر",
    MailType9: "تسجيل جديد من مدرب",
    MailType10: "تنشيط حساب مدرب",
    MailType11: "تأكيد طلب تسجيل في مقرر",
    PracticalForTrainee: "العملي للمتدرب",
    ConfirmAttended: "تأكيد الحضور",
    Fair: "متوسط",
    Good: "جيد",
    VeryPoor: "ضعيف جدا",
    Unacceptable: "غير مقبول",
    Poor: "ضعيف",
    Acceptable: "مقبول",
    VeryGood: "جيد جدا",
    Excellent: "ممتاز",
    Publish: "نشر",
    InstructorsOfThatCourse: "مدرب هذا المقرر",
    CoursePerTrainee: "مقرر لكل متدرب",
    Transportation: "مواصلات",
    TabletOrHandout: "تابلت او الجهاز",
    HostingFees: "رسوم الاستضافة",
    OfTrainee: "# عدد المتدربين",
    FeePerTrainee: "الأجر عن كل متدرب",
    TerminalAllowance: "بدل المحطة",
    OfTickets: "# عدد التذاكر",
    CostPerTicket: "التكلفة لكل تذكرة",
    AirTicket: "تذكرة طيران",
    Travel: "السفر",
    ClassRoomFees: "رسوم تشغيل الفصول الدراسية",
    DSAweekends: "عطلة نهاية الأسبوع",
    Passwordchangedsuccessfully: "تم تغيير الرقم السري بنجاح",
    ConfirmationDone: "تم التأكيد ",
    Done: "تم  ",
    Wrong: "خطأ",
    RejectedDone: " تم الرفض ",
    Mailissentsuccessfully: " تم ارسال البريد بنجاح ",
    TotalEvaluationMeanPercentagemustbelessthan100: "يجب أن يكون متوسط النسبة المئوية للتقييم أقل من 100٪",

    PleaseEnterAllQuestionWeight: "الرجاء إدخال درجة كل الأسئلة",
    PleaseEnterAllQuestionTime: "الرجاء إدخال وقت كل الأسئلة",
    TotalExamPercentagemustbe100: "يجب أن تكون نسبة الامتحان الإجمالية 100٪",
    CourseFeeChargedToParticipantis: "رسوم الدورة المفروضة على المشاركين",
    Yourrequestsubmittedsuccessfully: "تم تقديم طلبك بنجاح",
    Unexpectederrorpleasetryagain: "خطأ غير متوقع يرجى المحاولة مرة أخرى",
    thereareaproblem: "هناك مشكله ",
    MarkAsReadisDoneSuccessfully: "وضع علامة على  ما تمت قراءته بنجاح",
    PleaseaddallrequiredcontactinfoEmailMobile: "الرجاء إضافة جميع معلومات الاتصال المطلوبة البريد الإلكتروني والجوال",
    PleaseaddallrequiredcontactinfoEmailWorkEmailMobile: "الرجاء إضافة جميع معلومات الاتصال المطلوبة البريد الإلكتروني والبريد الإلكتروني للعمل والجوال",
    PleaseaddallrequiredcontactinfoEmailWorkEmailMobileFromContact: "الرجاء إضافة جميع معلومات الاتصال المطلوبة البريد الإلكتروني والبريد الإلكتروني للعمل والجوال من جهة الاتصال",
    PleaseaddallrequiredcontactinfoWorkEmail: "الرجاء إضافة جميع معلومات الاتصال المطلوبة البريد الإلكتروني للعمل",
    datasaveSuccessfully: "تم حفظ المعلومات بنجاح",
    ExamIsMarkedSuccessfully: "تم تصحيح الامتحان بنجاح",
    registrationSuccessfulandyourrequestunderreview: "تم التسجيل بنجاح وطلبك قيد المراجعة",
    DailySubsistence: "بدل الإقامة اليومي",
    InstructorFeeReport: "رسوم المدرب اليومية لإعداد التقارير والتقرير",
    SubTotal: "المجموع الفرعي",
    OfDays: " # عدد الايام",
    OfCourses: " # عدد المقررات",
    FeePerDay: "الرسوم في اليوم",
    InstructorFee: "رسوم المدرب يوميا لتسليم الدورات",
    InstructorServices: "خدمات المدرب",
    CourseImage: "صورة البرنامج/المقرر",
    CourseContent: "محتوى المقرر",
    Prerequisite: "المتطلبات المسبقة",
    Objectives: "أهداف التعليم",
    DiplomaCode: "كود الدبلومة",
    About: "عن",
    PleaseUploadVisaProof: "يرجى رفع إثبات التأشيرة",
    PleaseProvSubmit: "يرجى الانتظار حتى مراجعة البيانات المقدمة الخاصة بك",
    PleaseProvReg: "يرجى الانتظار حتى الموافقة على التسجيل",
    PleaseProv: "يرجى الانتظار حتى الموافقة على التأشيرة الخاصة بك",
    FlightTicketAttachment: "مرفق تذكرة طيران",
    VisaProofAttachment: "مرفق إثبات التأشيرة",
    VisaOnArrival: "تاشيرة الدخول عند الوصول",
    PassportAttachment: "مرفق جواز السفر",
    YourAddmissionTestDegree: "درجة اختبار القبول الخاصة بك",
    CoursesResult: "نتائج المقررات",
    ChooseCategoryFoQuestion: "اختر الفئة للحصول على سؤالها",
    AssignInstructorToMark: "تعيين مدرب للتصحيح",
    AnnualPlanCode: "رمز خطة التدريب/المقرر",
    BackToLogin: "العودة إلى تسجيل الدخول",
    SendCode: "ارسال الكود",
    RecPasswordNote: "يرجى إدخال عنوان بريدك الإلكتروني وسنرسل لك رمز التحقق لإعادة تعيين كلمة المرور الخاصة بك.",
    RecoverYourPassword: "استعادة كلمة المرور الخاصة بك",
    ShowWithAnswers: "أظهر مع الإجابات",
    ProposalTitle: "عنوان الاقتراح",
    ContactPersonPhone: "رقم الهاتف الشخصي *",
    ContactPersonName: "اسم الشخص *",
    ContactPersonEmail: "البريد الإلكتروني الخاص *",
    AddInstructor: "اضافة مدرب",
    RoomPrice: "سعر الغرفة",
    Single: "فردية",
    Double: "ثنائية",
    Triple: "ثلاثية",
    PercMark: "علامات المتدربين بالدرجة المئوية",
    ContainsSpecialCharacter: "يحتوي على حرف خاص",
    ContainsUppercase: "يحتوي على أحرف كبيرة",
    ContainsNumber: "يحتوي على رقم",
    Characters: "حروف",
    NewPassNote: "الرجاء إدخال كلمة المرور الجديدة الخاصة بك",
    ResetPassword: "إعادة تعيين كلمة المرور",
    Item: "بند",
    Update: "تعديل",
    AddNew: "اضافة جديد",
    Section: "القسم *",
    SuperviserEMail: "البريد الإلكتروني للمشرف *",
    LastName: "الاسم الاخير *",
    MiddleName: "الاسم الأوسط *",
    FirstName: "الاسم الاول *",
    WorkEmail: " بريد العمل * ",
    DocumentNumber: "ؤقم المستند",
    RevisionNumber: "رقم الحجز",
    RevisionDate: "تاريخ الحجز",
    RemoveImage: "مسح الصورة",
    UpdateImage: "تحديث الصورة",
    ParentCategory: "التصنيف الام",
    DailyFees: "الرسوم اليومية",
    AttachmentType: "نوع المرفق",
    PracticalCategory: "تصنيف الامتحانات العملي",
    CourseFees: "تكلفة المقرر الدراسي",
    EducationDegreeTypes: "أنواع الدرجات التعليمية",
    IsPayed: "مدفوع",
    Amount: "الكمية",
    Check: "تحقق من",
    Body: "النص",
    SelectProposalTemplate: "Select Proposal Template",
    StatusComment: "تعليق الحالة",
    CourseModules: "وحدات المقرر الدراسي",
    DocsAndHand: "التوثيق والمنشورات",
    CommaSeperated: "إضافة من يجب أن يحضر بفاصبة مفصولة (,)",
    IntroductionAbout: "مقدمة حول",
    Days: "الايام",
    CourseClassTests: "اختبارات البرنامج الفعلي",
    AdmissionTests: "اختبارات القبول",
    ParentStatus: "الحالة الام",
    EmailSeparate: "البريد الإلكتروني مفصول بـ",
    Birthdate: "تاريخ الميلاد",
    Comment: "تعليق",
    FeMale: "انثى",
    Male: "ذكر",
    Gender: "الجنس",
    CourseRegistrations: "التسجيلات في برنامج",
    CourseRequests: "طلبات تسجيل ببرنامج",
    CoursesRequest: "طلب تسجيل ببرنامج",
    StatusMail: "بريد الحالة",
    StatusName: "اسم الحالة",
    Close: "اغلاق",
    Reject: "رفض",
    Confirm: "تاكيد",
    Request: "الطلب",
    CourseClassNo: "رقم التدريب الفعلي",
    CourseClassDetail: "تفاصيل التدريب الفعلي",
    TimeInMinute: "الوقت بالدقائق",
    NumberOfBed: "عدد السراير",
    DefaultPrice: "السعر الافتراضي",
    AddFacility: "اضافة مرفق",
    AdvertisementPhone: "هاتف الاعلان",
    AdvertisementResponsible: "مسؤلي الاعلان",
    MinTimeOfMarkExamPerDay: "أقل وقت لتصحيح الامتحان باليوم",
    Image: "صورة",
    AddTrainingAid: "اضافة مرفق",
    MaxNoOfTrainee: "العدد الأقصى للمتدرب",
    Year: "سنة",
    Calender: "التقويم",
    For: "ل",
    MinNoOfTrainee: "اقل عدد من المتدربين",
    DescriptionOfAttachment: "وصف المرفق",
    Description: "الوصف",
    AnswerText: "نص الاجابة",
    AddAttachmentAnswer: "اضافة مرفق للأجابة",
    AddTextAnswer: "أضف إجابة نصية",
    IsRight: "صحيح؟",
    Mark: "العلامة",
    TotalFeesForTrainee: "إجمالي الرسوم الخاصة بالمتدرب",
    AddSector: "إضافة حكومي/خاص",
    InstructorConfirmAttended: "تأكيد حضور من المعلم",
    AddArea: "اضافة منطقة",
    WorkArea: "منطقة العمل",
    Work: "العمل",
    ResendCode: "اعادة ارسال الكود",
    ObtainedDate: "تاريخ الحصول عليها",
    AddLanguage: "اضافة لغة",
    SchoolOrUniversity: "مدرسة او جامعة",
    ContentText: "نص المحتوى",
    EducationDegreeType: "نوع الدرجة العلمية",
    IsInstuctor: "مدرب؟",
    IsPracticalAssessor: "مقيم عملي؟",
    PracticalAssessor: "مقيم عملي",
    IsExaminer: "ممتحن؟",
    Examiner: "ممتحن",
    URL: "الرابط",
    IsNew: "جديد؟",
    UserName: "اسم المستخدم",
    OrganizationName: "* اسم المؤسسة",
    Date: "التاريخ",
    AttachmentDescription: "وصف المرفق",
    AddContact: "اضافة جهة اتصال",
    ContactText: "نص جهة الاتصال",
    NoStatus: "بدون حالة",
    BudgetForCourse: "ميزانية التدريب",
    BudgetForTrainee: "ميزانية المتدرب",
    AnswerDate: "تاريخ الاجابة",
    NoAnswer: "لا توجد اجابة",
    TraineeAnswer: "إجابة المتدرب",
    UploadByTrainee: "تم تحميل بواسطة المتدرب",
    ExtraTraineeAnswer: "اجابات المتدرب الاضافية",
    TraineeName: "اسم المتدرب",
    NoOfTrainee: "عدد المتدربين",
    OrganizationContact: "تواصل المؤسسات",
    Organization: "المؤسسة",
    Customer: "المؤسسة",
    RequestStartDate: "تاريخ بداية الطلب",
    Register: "تسجيل",
    CurrentStatus: "الحالة الحالية",
    Trainee: "المتدرب",
    MailBody: "نص البريد",
    ShowQuestion: "مشاهدة الاسئلة",
    ParticipationRange: "درجة المشاركة من 1 إلى 10",
    TrainingOrderNumberCourseClass: "رقم التدريب",
    TrainingOrderNumber: "رقم التدريب",
    LoadTrainee: "تحميل المتدربين",
    Download: "تحميل",
    Type: "النوع",
    ViewPorposal: "مشاهدة الاقتراح",
    Version: "اصدار",
    Color: "اللون",
    ExcellentDegree: "درجة الامتياز",
    Failed: "فشل",
    PassInfo: "بيانات النجاح",
    PassDegreeIn: "درجة النجاح في ",
    PassDegree: "درجة النجاح",
    Back: "رجوع",
    Grade: "درجة",
    Weight: "وزن",
    Pass: "نجاح",
    Answers: "الاجابات",
    QuestionType: "نوع السؤال",

    QuestionNum: "رقم السؤال",
    InstructorsByCourse: "المدربين عن طريق البرامج",
    AllInstructors: "كل المتربين",
    NewModule: "وحدة جديدة",
    LastModuleCode: "كود الوحدة الأخيرة",
    SessionDay: "يوم المحاضرة",
    Session: "المحاضرة",
    Print: "طباعة",
    Submit: "حفظ",
    Cancel: "عدم الحفظ",
    ModelAnswer: "نموذج الاجابة",
    QuestionText: "السؤال",
    NumberOFQuestion: "عدد الاسئلة",

    ShoWHideTamplate: "اظهار /اخفاء نموذج التدريب",
    MailTemplate: "نموذج التدريب",
    IsRegistration: "مسجل؟",
    Delete: "مسح",
    MailType: "نوع البريد",
    ConfirmedRegistration: "تأكيد التسجيل",
    TotalRegistration: "مجموع المسجلين",
    CurrentPosition: "الموقف الحالي",
    ClassRoomName: "اسم غرفة التدريس",
    StartExam: "ابدأ الاختبار",
    CourseStartDate: "تاريخ بداية المقرر/التدريب",
    Content: "المحتوى",
    AddSession: "اضافة محاضرة/جلسة",
    CourseHours: "عدد ساعات المقرر",
    ReviewCode: "كود المراجعة",
    TypeName: "النوع",
    From: "من تاريخ",
    To: "الي تاريخ",
    DateFrom: "من تاريخ",
    DateTo: "الي تاريخ",
    Start: "بداية التاريخ",
    End: "نهاية التاريخ",
    EndDate: "تاريخ الانتهاء",
    Subject: "الموضوع",
    Hours: "ساعات",
    VisiableByTrainee: "مرئي من قبل المتدرب",
    NewTrainingAd: "مساعدة تدريب جديدة",
    TrainingAd: "مساعدات التدريب",
    Num: "العدد",
    Percentage: "النسبة المئوية",
    EvaluationMean: "التقييم",
    EvaluationMain: "التقييم",

    Title: "عنوان/لقب",
    RequestLocation: "مقر الدراسة/التدريب",
    RegistrationDue: "تاريخ استحقاق التسجيل",
    References: "المراجع",
    StartDate: "تاريخ البدأ",
    SortBy: "التصنيف حسب",
    RoomType: "نوع الغرفة",
    WithAccommodation: "مع الإقامة",
    FlightTicket: "تذكرة الطيران",
    VisaProof: "إثبات التأشيرة",
    PassportPath: "مسار جواز السفر",
    PassportNumber: "رقم جواز السفر",
    Result: "النتيجة",
    ExamCode: "كود الامتحان ",
    NameAsPassport: "اسم جواز السفر",
    EndOfModule: "نهاية الوحدة",
    DurationInHour: "المدة الزمنية للمقرر بالساعة",
    Category: "الفئة",
    CourseClassCode: "كود البرنامج الفعلي",
    CourseCode: "كود/رقم المقرر",
    InternalCourseCode: "كود المقرر الداخلي",
    Code: "كود",
    ContactPersonJobTitle: "المسمى الوظيفي لجهة الاتصال *",
    JobTitleRequied: "العنوان الوظيفي *",
    JobTitle: "العنوان الوظيفي",
    FullName: "الاسم بالكامل",
    Price: "السعر",
    ExamStartDate: "تاريخ بداية الامتحان",
    ExamType: "نوع الامتحان",
    AddRule: "اضافة قاعدة امتحان",
    DeliveryMethod: "طريقة التعليم",
    Reset: "اعادة تعيين",
    Search: "بحث",
    Name: "الاسم",
    Action: "العمليات",
    Module: "وحدة",
    DiplomaCourses: "برامج الدبلومة",
    NotifyAccordingToIndustrySector: "اشعار حسب حكومي/خاص",
    InstructorIndustrySector: "حكومي/خاص للمدرب",
    IndustrySector: "حكومي/خاص",
    OtherCourse: "برنامج/تدريب اخر",
    OtherLanguage: "لغة اخرى",
    CourseLanguage: "لغة التدريب/التعليم",
    CourseLanguageName: "اسم لغة التدريب/التعليم",
    PreferredLanguage: "اللغة المفضلة",
    Level: "مستوى التدريب",
    Period: "فترة",
    ClassNo: "رقم البرنامج الفعلي",
    UpCamminCourse: "البرامج الفعلية القادمة",
    HomeTitle: "مرحبا بكم في نظام إدارة التدريب",
    UserTitle: "لقب المستخدم",
    TrainingStrategy: "خطة/استراتيجية التدريب",
    Status: "الحالة",
    SystemMailTemplate: "نماذج بريد النظام",
    StatusMailTemplate: "نماذج حالات البريد",
    RoomHotelPrice: "تسعير غرف الفندق",
    RoomHotelType: "انواع غرف الفندق",
    RoomHotelFacility: "مرفقات غرفة الفندق",
    RoomHotel: "غرف الفندق",
    ReportManagement: "ادارة التقارير",
    QuestionLevel: "مستوى السؤال",
    Provider: "الجهة المنسقة",
    ProposalTemplate: "انشاء نماذج للعروض",
    ProposalStatus: "حالة العروض",
    PopulationList: "معنيون المقرر",
    PaymentType: "انواع الدفع",
    ParticipationType: "نوع المشاركة",

    MaterialType: "انواع مواد برامج الدراسة",
    MaritalStatus: "الحالة الإجتماعية",
    Language: "اللغة",
    GeneralSetting: "الاعدادات العامة",
    GenerateCode: "انشائ الكود",
    GeneralImage: "الصور العامة",
    Facility: "مساعدات التدريب",
    EducationDegree: "درجة التعليم",
    Documentation: "المستندات",
    CourseType: "طريقة التعليم",
    CourseLevel: "مستوى المقرر/البرنامج",
    CourseCategory: "فئة المقرر/البرنامج",
    Country: "البلد",
    ContactType: "نوع الاتصال",
    ClassRoom: "غرفة التدريس",
    CustomerFeedbackCategory: "فئة التقييم",
    AreaOfStudy: "مجال التدريب/التعليم",
    AnnualCalender: "التقويم السنوي",
    AdvertisementEmail: "البريد الإلكتروني للإعلان",
    AdditionalServices: "خدمات إضافية",
    Setting: "ضبط عمليات بحث النظام",
    Trainees: "المتدربين",
    Organizations: "المؤسسات او الشركات",
    Customers: "المؤسسات او الشركات",
    UserManagement: "ادارة المستخدمين",
    Users: "المستخدمين",
    CoursePassStatistics: "إحصائيات اجتياز البرنامج الدراسي",
    QuestionPassStatistics: "إحصائيات اجتياز السؤال",
    Dashboard: "لوحة القيادة",
    RecordsReports: "السجلات والتقارير",

    FeedbackQuestion: "اسئلة التقييم",
    Feedback: "التقييم",
    PracticalProcess: "انشاء الامتحان العملي",
    PracticalEvaluationQuestion: "اسئلة امتحانات العملي",
    PracticalExamination: "امتحانات العملي",
    ExamGeneration: "انشاء الامتحان",
    ExamRule: "قواعد الامتحان",
    QuestionBank: "بنك الاسئلة",
    ExaminationManagement: "ادارة الامتحانات",
    TraineeExamsAnswers: "إجابات امتحانات المتدربين",
    TraineeFollow: "تتبع المتدربين",
    AssessmentResult: "نتائج التقييم",
    AssessmentProcess: "تأدية التقييم",
    AssessmentCreation: "انشاء التقييم",
    AssessmentQuestion: "اسئلة التقييم",
    InstructorAssessment: "تقييم المدربين",
    Instructor: "المدرب",
    TraineeCertification: "شهادات المتدربين",
    FollowCourseRequest: "قم بإجراء أو متابعة طلب اللتحاق ببرنامج",
    FollowRegistration: "تتبع طلب التسجيل ببرنامج",
    CourseClass: "البرامج الفعلية",
    CourseRequest: "طلب التحاق ببرنامج دراسي",
    CourseRegistration: "طلب تسجيل ببرنامج دراسي",
    EnrollmentManagement: "ادارة التسجيل",
    advertisement: "الإعلانات",
    RoomPlan: "خطة غرف الدراسة",
    YearSummary: "ملخص الخطة الزمنية",
    AnnualPlan: "الخطة الزمنية",
    Holiday: "الاجازات الرسمية",
    ExamResult: "نتائج الامتحانات",
    CourseFeedback: "تقييم البرنامج الدراسي",
    YourExams: "امتحاناتك",
    CourseMaterial: "مواد برنامج الدراسة",
    CourseCatalog: "برامج الدراسة",
    Course: "البرنامج الدراسي",
    TraineeCoursesPass: "اجتياز دورات المتدربين",
    TraineeFeedback: "تقييم المتدربين",
    PracticalDegrees: "درجات النشاط العملي",
    MarkExam: "تصحيح الامتحانات",
    TraineeParticipation: "حضور المتدربين",
    TraineeAttendance: "غياب المتدربين",
    Schedule: "جدول المواعيد",
    Planning: "الخطة العامة للدراسة/التدريب",
    Home: "الصفحة الرئيسية",
    Diplomas: "الدبلومات",
    CourseName: "اسم البرنامج الدراسي",
    TraineeFullName: "اسم المتدرب بالكامل",
    Email: "البريد الالكتروني",
    PhoneNumber: "رقم التليفون",
    Analytics: "تحليلات",
    LogActions: "تتبع الحركات",
    LogActionDescription: "وصف الحركة",
    SectionName: "اسم القسم",
    CreatedDate: "التاريخ",
    FeedbackAction: "تفاصيل التقييم",
    FeedbackActionEdit: "عرض تفاصيل التقييم",
  },
  de: {
    Dashboard: 'Instrumententafel',
    eCommerce: 'eCommerce',
    Apps: 'Apps',
    Todo: 'Machen',
    Chat: 'Plaudern',
    Email: 'Email',
    Calendar: 'Kalender',
    FullCalendar: 'Calendrier completVollständiger Kalender',
    SimpleCalendar: 'Einfacher Kalender',
    Shop: 'Geschäft',
    Cart: 'Wagen',
    WishList: 'Wunschzettel',
    Checkout: 'Auschecken',
    UI: 'UI',
    DataList: 'Datenliste',
    ListView: 'Listenansicht',
    ThumbView: 'Daumenansicht',
    Grid: 'Gitter',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Farben',
    Card: 'Karte',
    Basic: 'Basic',
    Statistics: 'Statistiken',
    Analytics: 'Analytics',
    CardActions: 'Kartenaktionen',
    CardColors: 'Kartenfarben',
    Table: 'Tabelle',
    agGridTable: 'agGrid-Tabelle',
    Components: 'Komponenten',
    Alert: 'Warnen',
    Avatar: 'Benutzerbild',
    Badge: 'Abzeichen',
    Breadcrumb: 'Breadcrumb',
    Button: 'Taste',
    ButtonGroup: 'Schaltflächengruppe',
    Chip: 'Chip',
    Collapse: 'Zusammenbruch',
    Dialogs: 'Dialoge',
    Divider: 'Teiler',
    DropDown: 'Dropdown-Liste',
    List: 'Liste',
    Loading: 'Wird geladen',
    Navbar: 'Navbar',
    Notifications: 'Benachrichtigungen',
    Pagination: 'Seitennummerierung',
    Popup: 'Pop-up',
    Progress: 'Fortschritt',
    Sidebar: 'Seitenleiste',
    Slider: 'Schieberegler',
    Tabs: 'Tabs',
    Tooltip: 'QuickInfo',
    Upload: 'Hochladen',
    FormsAndTable: 'Formulare und Tabelle',
    FormElements: 'Formularelemente',
    Select: 'Wählen',
    Switch: 'Schalter',
    Checkbox: 'Ankreuzfeld',
    Radio: 'Radio',
    Input: 'Eingang',
    NumberInput: 'Nummer eingeben',
    Textarea: 'Textbereich',
    FormLayouts: 'Formularlayouts',
    FormWizard: 'Formzauberer',
    FormValidation: 'Formularvalidierung',
    FormInputGroup: 'Formulareingabegruppe',
    Pages: 'Seiten',
    Authentication: 'Authentifizierung',
    Login: 'Anmeldung',
    Register: 'Registrieren',
    ForgotPassword: 'Passwort vergessen',
    ResetPassword: 'Passwort zurücksetzen',
    LockScreen: 'Bildschirm sperren',
    Miscellaneous: 'Verschiedenes',
    ComingSoon: 'Demnächst',
    Error: 'Error',
    404: '404',
    500: '500',
    NotAuthorized: 'Nicht berechtigt',
    Maintenance: 'Instandhaltung',
    Profile: 'Profil',
    Invoice: 'Rechnung',
    FAQ: 'FAQ',
    Search: 'Suche',
    KnowledgeBase: 'Wissensbasis',
    ChartsAndMaps: 'Diagramme und Karten',
    Charts: 'Diagramme',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Karte',
    Extensions: 'Erweiterungen',
    QuillEditor: 'Quill-Editor',
    DragAndDrop: 'Ziehen und loslassen',
    Datepicker: 'Datumsauswahl',
    DatetimePicker: 'Datum / Uhrzeit-Auswahl',
    AccessControl: 'Zugangskontrolle',
    I18n: 'I18n',
    Carousel: 'Karussell',
    Clipboard: 'Zwischenablage',
    ContextMenu: 'Kontextmenü',
    StarRatings: 'Sterne Bewertungen',
    Autocomplete: 'Autovervollständigung',
    Tree: 'Baum',
    // "Import/Export": 'Einführen/Export',
    Import: 'Einführen',
    Export: 'Export',
    ExportSelected: "Auswahl exportieren",
    Others: 'Andere',
    MenuLevels: 'Menüebenen',
    MenuLevel2p1: 'Menüebene 2.1',
    MenuLevel2p2: 'Menüebene 2.2',
    MenuLevel3p1: 'Menüebene 3.1',
    MenuLevel3p2: 'Menüebene 3.2',
    DisabledMenu: 'Deaktiviertes Menü',
    Support: 'Unterstützung',
    Documentation: 'Dokumentation',
    RaiseSupport: 'Unterstützung erheben',
    demoTitle: 'Kartentitel',
    demoText: 'Kuchen Sesam Schnaps Cupcake Lebkuchen Dänisch Ich liebe Lebkuchen. Apfelkuchen-Torte-Jujuben chupa chups muffin halvah Lutscher. Schokoladenkuchenhaferkuchen Tiramisu-Marzipanzuckerpflaume. Donut süße Kuchen Hafer Kuchen Dragée Obstkuchen Zuckerwatte Zitrone Tropfen.',
    LogActions: 'Log Actions',
    LogActionDescription: "Description",
    SectionName: "Section Name",
    CreatedDate: "Created Date",
    FeedbackAction: "Feedback Action",
    FeedbackActionEdit: "Feedback Action View",
  },
  fr: {
    Dashboard: 'Tableau de bord',
    eCommerce: 'commerce électronique',
    Apps: 'Applications',
    Todo: 'Faire',
    Chat: 'Bavarder',
    Email: 'Email',
    Calendar: 'Calendrier',
    FullCalendar: 'Calendrier complet',
    SimpleCalendar: 'Calendrier simple',
    Shop: 'Boutique',
    Cart: 'Chariot',
    WishList: 'Liste de souhaits',
    Checkout: 'Check-out',
    UI: 'UI',
    DataList: 'Liste de données',
    ListView: 'Voir la liste',
    ThumbView: 'Thumb View',
    Grid: 'la grille',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Couleurs',
    Card: 'Carte',
    Basic: 'De base',
    Statistics: 'Statistiques',
    Analytics: 'Analytique',
    CardActions: 'Actions de carte',
    CardColors: 'Couleurs de la carte',
    Table: 'Table',
    agGridTable: 'tableau agGrid',
    Components: 'Composants',
    Alert: 'Alerte',
    Avatar: 'Avatar',
    Badge: 'Badge',
    Breadcrumb: 'Breadcrumb',
    Button: 'Bouton',
    ButtonGroup: 'Groupe de boutons',
    Chip: 'Puce',
    Collapse: 'Effondrer',
    Dialogs: 'Dialogues',
    Divider: 'Diviseur',
    DropDown: 'Menu déroulant',
    List: 'liste',
    Loading: 'Chargement',
    Navbar: 'Barre de navigation',
    Notifications: 'Les notifications',
    Pagination: 'Pagination',
    Popup: 'Apparaitre',
    Progress: 'Le progrès',
    Sidebar: 'Barre latérale',
    Slider: 'Curseur',
    Tabs: 'Onglets',
    Tooltip: 'Info-bulle',
    Upload: 'Télécharger',
    FormsAndTable: 'Formulaires et tableau',
    FormElements: 'Éléments de formulaire',
    Select: 'Sélectionner',
    Switch: 'Commutateur',
    Checkbox: 'Case à cocher',
    Radio: 'Radio',
    Input: 'Contribution',
    NumberInput: 'Nombre d\'entrée',
    Textarea: 'Textarea',
    FormLayouts: 'Dispositions de formulaire',
    FormWizard: 'Assistant de formulaire',
    FormValidation: 'Validation du formulaire',
    FormInputGroup: 'Groupe de saisie de formulaire',
    Pages: 'Pages',
    Authentication: 'Authentification',
    Login: 'S\'identifier',
    Register: 'registre',
    ForgotPassword: 'Mot de passe oublié',
    ResetPassword: 'réinitialiser le mot de passe',
    LockScreen: 'Écran verrouillé',
    Miscellaneous: 'Divers',
    ComingSoon: 'Arrive bientôt',
    Error: 'Erreur',
    404: '404',
    500: '500',
    NotAuthorized: 'Pas autorisé',
    Maintenance: 'Entretien',
    Profile: 'Profil',
    Invoice: 'Facture d\'achat',
    FAQ: 'FAQ',
    Search: 'Chercher',
    KnowledgeBase: 'Base de connaissances',
    ChartsAndMaps: 'Graphiques Et Cartes',
    Charts: 'Graphiques',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Carte',
    Extensions: 'Extensions',
    QuillEditor: 'Éditeur de piquants',
    DragAndDrop: 'Drag & Drop',
    Datepicker: 'Sélecteur de date',
    DatetimePicker: 'Sélecteur de date / heure',
    AccessControl: `Contrôle d'accès`,
    I18n: 'I18n',
    Carousel: 'Carrousel',
    Clipboard: 'Presse-papiers',
    ContextMenu: 'Menu contextuel',
    StarRatings: 'Classement par étoiles',
    Autocomplete: 'Terminé automatiquement',
    Tree: 'Arbre',
    // "Import/Export": 'Importation/Exportation',
    Import: 'Importation',

    ExportSelected: "Exporter sélectionné",
    Others: 'Autre',
    MenuLevels: 'Niveaux de menu',
    MenuLevel2p1: 'Niveau de menu 2.1',
    MenuLevel2p2: 'Niveau de menu 2.2',
    MenuLevel3p1: 'Niveau de menu 3.1',
    MenuLevel3p2: 'Niveau de menu 3.2',
    DisabledMenu: 'Menu désactivé',
    Support: 'Soutien',
    Documentation: 'Documentation',
    RaiseSupport: 'Augmenter le soutien',
    demoTitle: 'Titre de la carte',
    demoText: `Le gâteau au sésame s'enclenche au petit pain au pain d'épices danois J'adore le pain d'épices. Tarte aux pommes et jujubes chupa chups muffin halvah sucette. Tiramisu gâteau au chocolat gâteau d'avoine tiramisu prune sucre. Donut tarte sucrée gâteau à l'avoine dragée gouttes de fruits gâteau au citron en barbe à papa.`,
    LogActions: 'Log Actions',
    LogActionDescription: "Description",
    SectionName: "Section Name",
    CreatedDate: "Created Date",
    FeedbackAction: "Feedback Action",
    FeedbackActionEdit: "Feedback Action View",

  },
  pt: {
    Dashboard: 'painel de controle',
    eCommerce: 'comércio eletrônico',
    Apps: 'APPS',
    Todo: 'Façam',
    Chat: 'Bate-papo',
    Email: 'O email',
    Calendar: 'Calendário',
    FullCalendar: 'Calendário Completo',
    SimpleCalendar: 'Calendário Simples',
    Shop: 'fazer compras',
    Cart: 'Carrinho',
    WishList: 'Lista de Desejos',
    Checkout: 'Confira',
    UI: 'UI',
    DataList: 'Lista de dados',
    ListView: 'Exibição de lista',
    ThumbView: 'Thumb View',
    Grid: 'Grade',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Cores',
    Card: 'Cartão',
    Basic: 'Basic',
    Statistics: 'Estatisticas',
    Analytics: 'Analytics',
    CardActions: 'Ações do Cartão',
    CardColors: 'Cores do cartão',
    Table: 'Mesa',
    agGridTable: 'Tabela AgGrid',
    Components: 'Componentes',
    Alert: 'Alerta',
    Avatar: 'Avatar',
    Badge: 'Crachá',
    Breadcrumb: 'Breadcrumb',
    Button: 'Botão',
    ButtonGroup: 'Grupo de botões',
    Chip: 'Lasca',
    Collapse: 'Colapso',
    Dialogs: 'Diálogos',
    Divider: 'Divisor',
    DropDown: 'Suspenso',
    List: 'Lista',
    Loading: 'Carregando',
    Navbar: 'Navbar',
    Notifications: 'Notificações',
    Pagination: 'Paginação',
    Popup: 'Aparecer',
    Progress: 'Progresso',
    Sidebar: 'Barra Lateral',
    Slider: 'Controle Deslizante',
    Tabs: 'Guias',
    Tooltip: 'dica de ferramenta',
    Upload: 'Envio',
    FormsAndTable: 'Formulários e tabela',
    FormElements: 'Elementos do formulário',
    Select: 'Selecione',
    Switch: 'Interruptor',
    Checkbox: 'Caixa de seleção',
    Radio: 'Rádio',
    Input: 'Entrada',
    NumberInput: 'Entrada numérica',
    Textarea: 'Textarea',
    FormLayouts: 'Layouts de formulário',
    FormWizard: 'Assistente de Formulário',
    FormValidation: 'Validação de Formulário',
    FormInputGroup: 'Grupo de entrada de formulário',
    Pages: 'PÁGINAS',
    Authentication: 'Autenticação',
    Login: 'Entrar',
    Register: 'Registo',
    ForgotPassword: 'Esqueceu A Senha',
    ResetPassword: 'Redefinir Senha',
    LockScreen: 'Tela de bloqueio',
    Miscellaneous: 'Diversos',
    ComingSoon: 'Em breve',
    Error: 'Erro',
    404: '404',
    500: '500',
    NotAuthorized: 'Não autorizado',
    Maintenance: 'Manutenção',
    Profile: 'Perfil',
    Invoice: 'Fatura',
    FAQ: 'Perguntas frequentes',
    Search: 'Procurar',
    KnowledgeBase: 'Base de Conhecimento',
    ChartsAndMaps: 'Gráficos E Mapas',
    Charts: 'Gráficos',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Mapa',
    Extensions: 'Extensão',
    QuillEditor: 'Quill-Editor',
    DragAndDrop: 'Arraste e solte',
    Datepicker: 'Datepicker',
    DatetimePicker: 'Seletor de data e hora',
    AccessControl: 'Controle de acesso',
    I18n: 'I18n',
    Carousel: 'Carrossel',
    Clipboard: 'Prancheta',
    ContextMenu: 'Menu contextual',
    StarRatings: 'Classificações por estrelas',
    Autocomplete: 'autocompletar',
    Tree: 'Árvore',
    // "Import/Export": 'Importar/Exportar',
    Import: 'Importar',
    Export: 'Exportar',
    ExportSelected: "Exportar Selecionado",
    Others: 'Outras',
    MenuLevels: 'Níveis de Menu',
    MenuLevel2p1: 'Nível de menu 2.1',
    MenuLevel2p2: 'Nível de menu 2.2',
    MenuLevel3p1: 'Nível de menu 3.1',
    MenuLevel3p2: 'Nível de menu 3.2',
    DisabledMenu: 'Menu desativado',
    Support: 'Apoio, suporte',
    Documentation: 'Documentação',
    RaiseSupport: 'Levantar Suporte',
    demoTitle: 'Título do cartão',
    demoText: `O sésamo do bolo agarra dinamarquês do pão-de-espécie do queque eu amo o pão-de-espécie. Torta de torta de maçã jujuba chupa chups muffin halvah pirulito. Ameixa do açúcar do maçapão do tiramisu do bolo da aveia do bolo de chocolate. Bolo de aveia de torta doce rosquinha dragée fruitcake algodão doce gotas de limão.`,
    LogActions: 'Log Actions',
    LogActionDescription: "Description",
    SectionName: "Section Name",
    CreatedDate: "Created Date",
    FeedbackAction: "Feedback Action",
    FeedbackActionEdit: "Feedback Action View",

  },

}
